import { cn } from "@/lib/cn";

/** The mark of seamap.io: a chart sheet, a depth contour and a sounding. */
export function LogoMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" aria-hidden="true" className={cn("size-7", className)}>
      <rect x="1.5" y="1.5" width="29" height="29" rx="8" className="fill-primary" />
      <path
        d="M5 20.5c3.2-3.6 6.4-3.6 9.6 0s6.4 3.6 9.6 0c1.1-1.2 2.2-2 3.3-2.3"
        fill="none"
        strokeWidth="2.2"
        strokeLinecap="round"
        className="stroke-primary-foreground"
      />
      <path
        d="M5 13.5c3.2-3.6 6.4-3.6 9.6 0s6.4 3.6 9.6 0"
        fill="none"
        strokeWidth="1.6"
        strokeLinecap="round"
        className="stroke-primary-foreground/55"
      />
      <circle cx="23.5" cy="9" r="2.1" className="fill-primary-foreground" />
    </svg>
  );
}

export function Logo({ className, compact = false }: { className?: string; compact?: boolean }) {
  return (
    <span className={cn("flex items-center gap-2", className)}>
      <LogoMark />
      {!compact && (
        <span className="flex flex-col leading-none">
          <span className="text-[15px] font-semibold tracking-tight">seamap.io</span>
          <span className="mt-0.5 text-[10.5px] text-muted-foreground">carte marine commune</span>
        </span>
      )}
    </span>
  );
}
